// File: src/components/impact/ImpactHero.js

import React from 'react';
import styles from './ImpactHero.module.css';
import ScrollAnimation from '../common/ScrollAnimation';
import { cn } from '../../utils/helpers';

const HERO_STATS = [
  {
    id: 'diversion',
    value: '100%',
    label: 'Landfill Diversion Rate',
    description: 'Every tonne processed stays out of landfill, permanently.',
  },
  {
    id: 'ghg',
    value: '90%',
    label: 'Reduction in GHG Emissions',
    description: 'Versus conventional organic waste disposal methods.',
  },
  {
    id: 'waste',
    value: '500K+',
    label: 'Target Tonnes Diverted Annually',
    description: 'And growing as GreenScience scales across North America.',
  },
];

function ImpactHero() {
  return (
    <section className={styles.section}>
      {/* Background layer */}
      <div className={styles.bg} aria-hidden="true" />

      <div className={cn('site-container', styles.inner)}>

        {/* Heading block */}
        <ScrollAnimation className={styles.headingBlock}>
          <p className={styles.eyebrow}>Our Impact</p>
          <h1 className={styles.heading}>
            Turning Waste Into&nbsp;a&nbsp;Win
            <br />
            <span className={styles.headingAccent}>For Everyone.</span>
          </h1>
          <p className={styles.subheading}>
            GreenScience doesn't just manage organic waste — it closes the loop.
            Every tonne processed becomes a measurable environmental, social,
            and economic benefit.
          </p>
        </ScrollAnimation>

        {/* Stat strip */}
        <div className={styles.statStrip}>
          {HERO_STATS.map((stat, i) => (
            <ScrollAnimation key={stat.id} delay={i * 120} className={styles.statItem}>
              <span className={styles.statValue}>{stat.value}</span>
              <span className={styles.statLabel}>{stat.label}</span>
              <span className={styles.statDesc}>{stat.description}</span>
            </ScrollAnimation>
          ))}
        </div>

      </div>
    </section>
  );
}

export default ImpactHero;